import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAllObjectType = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.OBJECTTYPE + `/getAll`);
};

export const getObjectTypeByGroupId = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.OBJECTTYPE + `/getByObjectgroup_id/${id}`);
};

export const createObjectType = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.OBJECTTYPE, data);
};

export const updateObjectType = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.OBJECTTYPE + `/${id}`, data);
};


export const deleteObjectType = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.OBJECTTYPE + `/${id}`);
};